
<template>
  



<v-footer
      
      padless
      
      
    >

 <v-row no-gutters>
      
      <v-col>
      
      <v-card
        flat
        tile
        class="lighten-1 grey--text text-center"

     
      
      >








        <v-card-text>
       
        </v-card-text>
  
        <v-card-text class="gray--text pt-0">
    
        </v-card-text>

        <a :href="$router.resolve({ path: '/' }).href"class="no-underline">
          <img src="@/assets/img/use/logoteczoav1.png" alt="Logo TecZoa" style="width: 80px; margin-top: 0px;">
    </a>
       
        
        <v-divider></v-divider>
  
        <v-card-text class="gray--text">
          {{ new Date().getFullYear() }}
        </v-card-text>
      </v-card>


        </v-col>
        
      </v-row>
    </v-footer>









</template>

<script>
  import ChapterDetails from '@/assets/data/chapterDetails.json'
 
  export default {
    data() {
      return {
        ChapterDetails:ChapterDetails
      }
    },
  }
</script>


<style>
.no-underline {
  text-decoration: none; /* Elimina el subrayado */
  color: inherit; /* Mantiene el color del texto fuerte */
}
</style>


